import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "react-phone-input-2/lib/style.css";
import "./login.css";
import login_img from "../../assets/images/login_img.png";
import eye from "../../assets/images/eye.png";
import Arrow from "../../assets/images/arrow-left.svg";
// import heart1 from "../../assets/images/heart.gif";
// import heart from "../../assets/images/heart2.gif";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import logo from "../../assets/images/logo.png";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { useForm } from "react-hook-form";
import CustomInput from "../common/Input/Input";
import ReCAPTCHA from "react-google-recaptcha";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

const Login = () => {
  const [captchaValue, setCaptchaValue] = useState(null);
  const [password, setPassword] = useState(false);
  const [loginData, setLoginData] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(600);
  const [resendCountdown, setResendCountdown] = useState(30);

  const [isResend, setIsResend] = useState(false);
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpShow, setOtpShow] = useState(false);
  const navigate = useNavigate();
  const { doLogin, currUserData, setProfileData } = useAuthContext();

  // console.log(value, otp, "otp");
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  console.log(error, "error");

  const handleCaptchaChange = (value) => {
    console.log("Captcha Value:", value);
    setCaptchaValue(value);
  };
  const handlelogin = async (data) => {
    console.log(data, "form");

    var payload = {
      // email: data.email,
      // password: data.password,
      email: data?.email,
      password: data?.password,
    };

    let res = await api(
      `api/v1/auth/Login`,
      payload,
      "postWithoutToken",
      "",
      ""
    );
    console.log(res, "dec");
    if (res && res.success) {
      setOtpShow(true);
      setLoginData(res?.data);
      setEmail(data?.email);
    } else {
    }
  };

  const getUserFromToken = (token) => {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  };

  const handleVerify = async () => {
    if (otp.some((digit) => digit.trim() === "")) {
      setError("Please enter all OTP fields.");
      return;
    } else {
      setError();
    }

    const otpNumber = otp.join("");
    var payload = {
      id: loginData?._id,
      otp: otpNumber,
    };

    let res = await api(
      `api/v1/auth/verifyOTP`,
      payload,
      "postWithoutToken",
      "",
      ""
    );

    if (res && res.success) {
      const getUserFromToken = async () => {
        try {
          return jwtDecode(res?.data?.token);
        } catch (error) {
          return null;
        }
      };
      doLogin({
        token: res?.data?.token || "",
        ...(await getUserFromToken()),
      });
      getProfile(res?.data?.token);
      navigate("/dashboard");
    }
  };

  const registerOptions = {
    email: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Enter a valid email address",
      },
    },
    password: { required: "password is required" },
  };

  const getProfile = async (token) => {
    console.log(token, "token");

    const res = await api(
      "api/v1/auth/getProfileData", // ✅ corrected API endpoint format
      {},
      "get",
      token,
      "",
      ""
    );

    if (res && res.status) {
      localStorage.setItem("profile", JSON.stringify(res?.data));
      setProfileData(res?.data);
    }
  };

  // Countdown Timer

  useEffect(() => {
    if (resendCountdown > 0) {
      const timer = setInterval(() => {
        setResendCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setIsResend(true);
    }
  }, [resendCountdown, loginData]);

  // Handle OTP input change
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if a digit is entered
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  // Handle Backspace for previous input
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = ""; // Clear current input
      } else if (index > 0) {
        inputRefs.current[index - 1].focus(); // Move to previous input
      }
      setOtp(newOtp);
    }
  };

  // Resend OTP
  const handleResendOTP = async () => {
    var payload = {
      email: email,
    };

    let res = await api(
      `api/v1/auth/resendOTP`,
      payload,
      "postWithoutToken",
      "",
      ""
    );

    if (res && res.success) {
      setOtp(["", "", "", "", "", ""]); // Clear OTP
      setResendCountdown(30); // Reset timer
      inputRefs.current[0]?.focus(); // Auto-focus first input
    }
  };

  return (
    <>
      <div className="loginModal">
        <div className="container-fluid">
          <div className="row">
            <div className="login_left">
              <div className="images">
                {/* <p>
                  Secure Access to Smarter
                  <br /> Hospital Management.
                </p> */}
                <img src={login_img} />
              </div>
            </div>
            <div className="login_reight">
              <div className="login-content">
                <div>
                  <img src={logo} alt="" />
                </div>
                {otpShow ? (
                  <>
                    <div className="otp_section mx-auto">
                      <h6>
                        <span onClick={() => setOtpShow(false)}>
                          {/* <Arrow /> */}
                          <img src={Arrow} />
                        </span>
                        Verify OTP
                      </h6>
                      <div className="mb-3 ">
                        <p className="mb-3">
                          Please enter the otp that sent to {email}
                        </p>
                        <div className="d-flex justify-content-between">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              type="text"
                              className="form-control text-center otp-input"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handleChange(e, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                              ref={(el) => (inputRefs.current[index] = el)}
                              // disabled={isExpired}
                            />
                          ))}
                        </div>
                        <small className="error">{error}</small>
                      </div>
                      {/* <p className="dont_recived text-center">
                        {isExpired ? (
                          <></>
                        ) : (
                          `Expires in ${Math.floor(countdown / 60)} : ${
                            countdown % 60
                          } `
                        )}
                      </p> */}

                      <button
                        className="mx-auto d-block btn_primary w-100 mb-4 mt-5"
                        type="submit"
                        // disabled={isExpired}
                        onClick={() => handleVerify()}
                      >
                        Submit
                      </button>
                      <p className="dont_recived text-center">
                        <>
                          <span
                            className={`btn-link ps-1 ${
                              isResend ? "text-primary" : "text-muted"
                            }`}
                            onClick={isResend ? handleResendOTP : undefined}
                            style={{
                              cursor: isResend ? "pointer" : "default",
                            }}
                          >
                            <span className="text-dark">Didn't get OTP ? </span>{" "}
                            Resend OTP{" "}
                            {resendCountdown > 0
                              ? Math.floor(resendCountdown)
                              : ""}
                          </span>
                        </>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <form
                      className="w-100"
                      onSubmit={handleSubmit(handlelogin)}
                    >
                      <h6>Login</h6>
                      <CustomInput
                        register={register}
                        label="Email Address"
                        name="email"
                        placeholder="Email"
                        type="text"
                        errors={errors.email}
                        validation={registerOptions.email}
                      />
                      <div className="Password">
                        <CustomInput
                          register={register}
                          label="Password"
                          name="password"
                          placeholder="Password"
                          type={password ? "text" : "password"}
                          errors={errors.password}
                          validation={registerOptions.password}
                        />
                        <span className="icon">
                          <img
                            onClick={() => setPassword(!password)}
                            src={eye}
                          />
                        </span>
                      </div>

                      <div className="forgotPassword">
                        <Link
                          to={"/forgot-password"}
                          className="float-end fs_16 "
                        >
                          FORGOT PASSWORD ?
                        </Link>
                      </div>
                      {/* Google reCAPTCHA */}
                      <ReCAPTCHA
                        sitekey="6Le5OvgqAAAAALGQke4eIifAL95LjsPqMfGzPBBc"
                        onChange={handleCaptchaChange}
                      />

                      <button
                        className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
                      >
                        Submit
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
